import type { 
  ResetPasswordRequest, 
  GenerateTokenRequest, 
  ValidateTokenRequest, 
  ChangePasswordRequest, 
  ResetPasswordState 
} from '../../../domain/models/reset-password'
import * as types from '../types/reset-password-types'

// Legacy actions (mantendo compatibilidade)
export const resetPasswordRequest = (payload: ResetPasswordRequest) => ({
  type: types.USER_RESET_PASSWORD_REQUEST,
  payload,
})

export const resetPasswordError = (payload: string) => ({
  type: types.USER_RESET_PASSWORD_ERROR,
  payload,
})

export const resetPasswordSuccess = (payload: boolean) => ({
  type: types.USER_RESET_PASSWORD_SUCCESS,
  payload,
})

export const resetPasswordReset = () => ({
  type: types.USER_RESET_PASSWORD_RESET,
})

// Generate Token Actions
export const generateTokenRequest = (payload: GenerateTokenRequest) => ({
  type: types.GENERATE_TOKEN_REQUEST,
  payload,
})

export const generateTokenSuccess = (payload: any) => ({
  type: types.GENERATE_TOKEN_SUCCESS,
  payload,
})

export const generateTokenError = (payload: string) => ({
  type: types.GENERATE_TOKEN_ERROR,
  payload,
})

// Validate Token Actions
export const validateTokenRequest = (payload: ValidateTokenRequest) => ({
  type: types.VALIDATE_TOKEN_REQUEST,
  payload,
})

export const validateTokenSuccess = (payload: any) => ({
  type: types.VALIDATE_TOKEN_SUCCESS,
  payload,
})

export const validateTokenError = (payload: string) => ({
  type: types.VALIDATE_TOKEN_ERROR,
  payload,
})

// Change Password Actions
export const changePasswordResetRequest = (payload: { params: ChangePasswordRequest; jwtToken?: string }) => ({
  type: types.CHANGE_PASSWORD_RESET_REQUEST,
  payload,
})

export const changePasswordResetSuccess = (payload: any) => ({
  type: types.CHANGE_PASSWORD_RESET_SUCCESS,
  payload,
})

export const changePasswordResetError = (payload: string) => ({
  type: types.CHANGE_PASSWORD_RESET_ERROR,
  payload,
})

// Utility Actions
export const resetPasswordUpdateState = (payload: Partial<ResetPasswordState>) => ({
  type: types.RESET_PASSWORD_UPDATE_STATE,
  payload,
})

export const resetPasswordResetState = () => ({
  type: types.RESET_PASSWORD_RESET_STATE,
})
